import { readJson, writeJson } from "./offlineStore";

// File des écritures de collection tentées hors ligne (étape 3 du mode
// hors ligne). Objet clé -> opération, PAS un tableau : la clé est
// getCollectionKey(cardId, variant), donc une nouvelle écriture sur la même
// carte écrase l'entrée précédente au lieu de s'empiler — rejouer la file
// donne directement le dernier état voulu, sans repasser par les états
// intermédiaires, et sans la faire grossir si l'utilisateur coche/décoche
// plusieurs fois la même carte pendant la coupure.
const QUEUE_PATH = "offline/write-queue.json";

// op: { type: "status", cardId, variant, status } | { type: "remove", cardId, variant }

export async function readQueue() {
  return (await readJson(QUEUE_PATH)) || {};
}

/** entries: { [key]: op } — fusionné en une seule lecture/écriture, pour
 * qu'une opération en masse (bulkMarkStatus/bulkRemoveStatus) ne fasse pas
 * une écriture disque par carte. */
export async function queueWrites(entries) {
  const queue = await readQueue();
  Object.assign(queue, entries);
  await writeJson(QUEUE_PATH, queue);
}

export async function removeFromQueue(keys) {
  const queue = await readQueue();
  keys.forEach(k => delete queue[k]);
  await writeJson(QUEUE_PATH, queue);
}

export async function queueSize() {
  return Object.keys(await readQueue()).length;
}

/** Vide la file. Réservé au changement de compte (lib/api.js login) : des
 * écritures faites hors ligne par un utilisateur ne doivent JAMAIS être
 * rejouées avec le token d'un autre. */
export async function clearQueue() {
  await writeJson(QUEUE_PATH, {});
}
